
import React, { Component } from 'react';
import landscape    from './contact_form.module.css';
import portrait      from './portrait.module.css';
import { Buffer }   from 'buffer';
import { Context }  from '../services/context';
import pic_bird     from '../pictures/Letterbird.avif';
import { Helmet }   from 'react-helmet';
import cx            from 'classnames';


const cx_header     = cx({[portrait.header]:  Context.portrait, [landscape.header]: !Context.portrait});
const cx_text       = cx({[portrait.text]:    Context.portrait, [landscape.text]:   !Context.portrait});
const cx_ul         = cx({[portrait.ul]:      Context.portrait, [landscape.ul]:     !Context.portrait});
const cx_li         = cx({[portrait.li]:      Context.portrait, [landscape.li]:     !Context.portrait});
const cx_text_wide  = cx([landscape.text_wide])


  //------------------------------------------------------------
  //
  //------------------------------------------------------------
class ContactForm extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
        message: '',
        formSubmitted: false, // New state to track form submission
        isSubmitButtonDisabled: true, // New state to control the submit button's disabled status
        emailFailed: false
        };
        
        this.state = {content_disabled: false}
    }

    componentDidMount() 
    {
        this.portrait = Context.portrait;
        //this.forceUpdate();
        window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    }

      //------------------------------------------------------------------
      //
      //------------------------------------------------------------------
      changeVisible(mode)
      {
        this.setState({content_disabled:mode})
      }

    //------------------------------------------------------------------
    //  Prepare the portrait output
    //------------------------------------------------------------------
    render()
    { 
      if (Context.portrait)
      {

        this.component = 
          <div className={portrait.backdrop}>

            <Helmet>
            <title>Contact to Blockchain Systems</title>
            <meta name="description" content="Shows that people with Trust.it registration can use the chain to communicate to Blockchain Systems" />
            <meta charset="utf-8" />
            </Helmet>

            <div className={portrait.header}>
            We’d love to hear your feedback!
            </div>
    
            <div className={portrait.text}> Priority access for registered Trust.it users.  
              <br/>Please use the app to contact us.<br />

  
              <br/>
              Alternatively, email us at feedback@backstepchain.com
            </div>
    
            <div  className= {portrait.image}>
              <img src = {pic_bird} alt="Letterbird in contact page" />
              <p>Our beautiful Chirp bird knows the way. Don’t forget to add a stamp—that’s how you feed it!.</p>
            </div>

          </div>
      }
      else
      {
          //------------------------------------------------------------
          //  Prepare landscape display
          
          
          this.component = 
          <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

            <Helmet>
            <title>Contact to Blockchain Systems</title>
            <meta name="description" content="Shows that people with Trust.it registration can use the chain to communicate to Blockchain Systems" />
            <meta charset="utf-8" />
            </Helmet>

            { ! this.state.content_disabled &&
            <div className={landscape.container}>

              <div className={landscape.item}> 
                <b>We’d love to hear your feedback!
                <br/>Priority access for registered Trust.it users. <br/> 
                <br/>Please use the app to contact us.<br/>
                <br/>Alternatively, email us at feedback@backstepchain.com
                </b> 
              </div>
         
           
            
              <div className = {landscape.grid_image}>
                <img src = {pic_bird} alt="Letterbird in contact page" className={landscape.bird} />
              </div>

              <div className={landscape.item}>
                <p><b>Our beautiful Chirp bird knows the way. Don’t forget to add a stamp—that’s how you feed it!.</b></p>
              </div>

            </div>  
           }
          </div>
      }
     return this.component;
    }
}

export default ContactForm;
